import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-steps-header',
    templateUrl: './steps-header.component.html',
    styleUrls: ['./steps-header.component.scss'],
    standalone: false
})
export class StepsHeaderComponent implements OnInit {
  @Input() step1: string;
  @Input() step2: string;
  @Input() step3: string;
  @Input() isStep1Active: boolean;
  @Input() isStep2Active: boolean;
  @Input() isStep3Active: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
